<mat-form-field>
  <mat-select [(ngModel)]="displayNumber"
              (ngModelChange)="displayNumberChanged($event)"
              placeholder="{{placeholder | translate}}"
              fxFill
              [disabled]="!canEdit">
    <mat-option *ngFor="let serviceNumber of displayNumbers" [value]="serviceNumber">
      {{serviceNumber.name}} ({{serviceNumber.phoneNumber | phoneNumberFormatter}})
    </mat-option>
  </mat-select>
</mat-form-field>
